import 'react';
import PropTypes from '../../prop-types/index.js';
import './Animate.js';

({
  appearOptions: PropTypes.object,
  enterOptions: PropTypes.object,
  leaveOptions: PropTypes.object,
  children: PropTypes.element
});
